export default {
    openLoading() {
      //loading请求等待
      this.loadings = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    closeLoading() {
      this.loadings.close();
    },
    /**
     * 计算容器可用高度（从容器顶部到视口底部）
     * @param {HTMLElement} container - 容器元素
     * @param {Object} options - 配置选项
     * @param {number} options.extraOffset - 额外偏移量（默认0）
     * @param {boolean} options.useOffsetTop - 是否使用容器 offsetTop（默认true）
     * @returns {number} 可用高度
     */
    getContainerAvailableHeight(container, options = {}) {
      const { extraOffset = 0, useOffsetTop = true } = options;

      if (!container) return 300;

      const viewportHeight = window.innerHeight;
      const offsetTop = useOffsetTop ? container.offsetTop : 0;

      return Math.max(viewportHeight - offsetTop - extraOffset, 200);
    }
}